<template>
	<div class="home">
		<bigLogo></bigLogo>
		<!-- スライド -->
		<div class="top-slider">
			<transition name="slide"><div class="slide slideImages" :style="{'background-image':'url(' + slidImages[slideNo]['image'] + ')'}" @click.stop="jump(slidImages[slideNo]['link'])" :key="slidImages[slideNo]['image']"></div></transition>
		</div>
		<!-- メインメニュー -->
		<div class="mainMenuArea">
			<div v-for="(item, k) in menus" class="menuPanel" :key="k">
				<menuItem :item="item" @menu_click="menu_click"></menuItem>
			</div>
		</div>
		<!-- ニュース -->
		<div style="background-color:#fff; margin-top:280px">
			<div class="subtitle">NEWS<div class="smalltitle">[ ニュース・トピック ]</div></div>
			<div class="newsArea">
				<div v-for="(news, k) in newslist" class="newsPanel" :key="k">
					<newsItem :item="news"></newsItem>
				</div>
			</div>
		</div>
		<!-- サイトマップ -->
		<sitemap></sitemap>
		<div v-if="iosBackground" class="ios_background" :style="{'background-image':'url(' + bgimage + ')'}"></div>
	</div>
</template>

<script>
// @ is an alias to /src
import Vue from 'vue'
import menuItem from '@/components/menuItem.vue'
import newsItem from '@/components/newsItem.vue'
import sitemap from '@/components/map.vue'
import bigLogo from '@/components/logo.vue'

export default {
	name: 'home',
	components: {
		'menuItem': menuItem,
		'newsItem': newsItem,
		'sitemap': sitemap,
		'bigLogo': bigLogo
	},
	data() {
		return {
			slidImages: [
				{
					image: require("@/assets/images/topSlide/image01.jpg"),
					imagemb: require("@/assets/images/topSlide/image01.jpg"),
					link: "/company/"
				},
				{
					image: require("@/assets/images/topSlide/image02.jpg"),
					imagemb: require("@/assets/images/topSlide/image02.jpg"),
					link: "/services/"
				},
				{
					image: require("@/assets/images/topSlide/image03.jpg"),
					imagemb: require("@/assets/images/topSlide/image03.jpg"),
					link: "/recruit/"
				}
			],
			slideNo: 0,
			slideNo2: 0,
			slideBgNum: 0,
			slideTimer: null,
			bgimage: require("@/assets/images/bgimage.jpg"),
			menus: [
				{
					image: require("@/assets/images/topSlide/image01.jpg"),
					title: "会社情報",
					link: "/company/"
				},
				{
					image: require("@/assets/images/topSlide/image02.jpg"),
					title: "事業内容",
					link: "/services/"
				},
				{
					image: require("@/assets/images/topSlide/image03.jpg"),
					title: "採用情報",
					link: "/recruit/"
				}
			],
			newslist: [],
			bodyScrollPos: 0,
			iosBackground: false
		}
	},
	beforeRouteEnter(to, from ,next) {
		next(vm => {
			if (to.hash.match(/^#/)) {
				let anc = to.hash.replace(/^#/, '');
				vm.$scrollTo("#" + anc);
			} else {
				vm.$scrollTo("#app");
			}
		});
	},
	afterEach(to, from) {
		
	},
	watch: {
		'$route': function(n, o) {
			if (n.hash.match(/^#/)) {
				let anc = n.hash.replace(/^#/, '');
				this.$scrollTo("#" + anc);
			} else {
				this.$scrollTo("#app");
			}
		}
	},
	mounted() {
		this.$nextTick(function(){
			let home = document.querySelector('.home');
			if (this.checkiPhone()) {
				this.iosBackground = true;
			} else {
				home.style.backgroundImage = 'url(' + this.bgimage + ')';
				home.style.backgroundSize = 'cover';
				home.style.backgroundPosition = 'center';
				home.style.backgroundAttachment = 'fixed';
			}
			
			window.addEventListener('scroll', this.scrollIn);
			
			this.getBlogTopics();
			
			this.onTimer();
		});
	},
	destroyed() {
		window.removeEventListener('scroll', this.scrollIn);
	},
	methods: {
		async getBlogTopics() {
			//console.log("getBlogTopics");
			try {
				let response = await Vue.$http.get('https://biibridge-labo.work/wp-json/wp/v2/posts?_embed&per_page=6');
				//console.log(response);
				if (response.data.length > 0) {
					for (let i = 0; i < response.data.length; i++) {
						let data = response.data[i];
						let image = undefined;
						if (data._embedded['wp:featuredmedia'].length > 0) {
							image = data._embedded['wp:featuredmedia'][0].source_url;
						}
						let item = {
							"date": data.date,
							"title": data.title.rendered,
							"text": data.excerpt.rendered,
							"link": data.link,
							"image": image
						}
						this.newslist.push(item)
					}
				}
			} catch (err) {
				//console.error(err);
			}
			return;
		},
		nextSlide() {
			this.slideBgNum = this.slideBgNum < this.slidImages.length - 1 ? this.slideBgNum += 1 : 0;
			this.slideNo = this.slideBgNum;
			this.slideNo2 = ((this.slideNo - 1) < 0) ? (this.slidImages.length - 1) : this.slideNo - 1;
		},
		onTimer() {
			this.slideTimer = setInterval(() => {
				this.nextSlide();
			}, 5000)
		},
		offTimer() {
			if(this.slideTimer === null) {
				this.onTimer();
			} else {
				clearInterval(this.slideTimer);
				this.slideTimer = null;
			}
		},
		menu_click(arg) {
			this.jump(arg);
		},
		jump(path) {
			this.$router.push(path);
		},
		scrollIn() {
			let items = document.querySelectorAll('.newsPanel');
			let s = document.documentElement.scrollTop || document.body.scrollTop;
			let w = window.innerHeight;
			
			for (let i = 0; i < items.length; i++) {
				let item = items[i];
				let p = item.offsetTop;
				if (s > p - w + 100) {
					item.classList.add("scrollIn");
				}
			}
		},
		checkiPhone() {
			let result = false;
			let ua = navigator.userAgent.toLowerCase();
			
			let isiPhone = (ua.indexOf('iphone') > -1);
			let isiPod = (ua.indexOf('ipod') > -1);
			let isiPad = (ua.indexOf('ipad') > -1);
			
			if (isiPhone || isiPod || isiPad){
				result = true;
			}
			return result;
		}
	}
}
</script>

<style lang="less">
.home {
	background-size: cover;
	background-position: center;
	background-attachment: fixed;
	
	.top-slider {
		position: relative;
		width: 100vw;
		height: calc(100vh - 100px);
		overflow: hidden;
		background-color: #fff;
		
		.slideImages {
			position: absolute;
			top: 0;
			left: 0;
			width: auto;
			height: auto;
			min-width: 100%;
			min-height: 100%;
			max-width: inherit;
			background-size: cover;
			background-position: center;
		}
	}
	
	.mainMenuArea {
		padding: 100px 80px 40px 80px;
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
		background-color: #fff;
		
		.menuPanel {
			width: 280px;
			margin-bottom: 40px;
		}
	}
	
	.newsArea {
		padding: 60px 80px 40px 80px;
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
		background-color: #fff;
		
		.newsPanel {
			width: 280px;
			height: 260px;
			margin-bottom: 40px;
			opacity: 0;
			transform: translate(0, 50px);
			transition: all 1s;
		}
		
		.newsPanel.scrollIn {
			opacity: 1;
			transform: translate(0, 0);
		}
	}
	
	.subtitle {
		position: relative;
		padding-top: 60px;
		font-size: 2.6rem;
		font-weight: bold;
		text-align: center;
		background-color: #fff;
		
		.smalltitle {
			font-size: 0.7rem;
			margin-top: -7px;
		}
	}
	
	.ios_background {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100vh;
		background-size: cover;
		background-position: center;
		z-index: -1;
	}
}

.slide-enter-active, .slide-leave-active {
	transition: transform .5s;
}
.slide-enter {
	transform: translateX(100vw);
}
.slide-leave-active {
	transform: translateX(calc(100vw * -1));
}

@media(max-width:420px) {
	.home {
		.top-slider {
			height: calc(100vh - 240px);
		}
		
		.mainMenuArea {
			padding: 60px 30px 0px 30px;
			display: flex;
			flex-wrap: wrap;
			justify-content: space-around;
			
			.menuPanel {
				width: 280px;
				height: 220px;
				margin-bottom: 40px;
			}
		}
		
		.newsArea {
			padding: 60px 30px 20px 30px;
			display: flex;
			flex-wrap: wrap;
			justify-content: space-around;
			
			.newsPanel {
				width: 280px;
				height: 260px;
				margin-bottom: 40px;
			}
		}
		
		.siteMapArea {
			padding: 60px 30px;
		}
	}
}
</style>
